import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from 'Containers/Public/Home/Home';
//import FormMockup from 'Containers/FormMockup';
import Login from 'Containers/Login/Login';
import TabDatatable from 'Containers/TabDatatable';
import CreateOrganization from 'Containers/Private/Organization/Create/CreateOrganization';
import EditOrganization from 'Containers/Private/Organization/Edit/EditOrganization';
import ListOrganization from 'Containers/Private/Organization/List/ListOrganization';
import ViewOrganization from 'Containers/Private/Organization/View/ViewOrganization';
import ExampleElements from 'Containers/ExampleElements';
//import { store } from 'Store';
import CDABatchDetail from 'Containers/Private/DataSubmission/CDABatchDetail';
import ListUsers from 'Containers/Private/User/List/ListUsers';
import CreateUser from 'Containers/Private/User/Create/CreateUser';
import ViewUser from 'Containers/Private/User/View/ViewUser';
import EditUser from 'Containers/Private/User/Edit/EditUser';
import ListPSOProfiles from 'Containers/Private/PSOProfile/List/ListPSOProfiles';
import ManageVendorAuth from 'Containers/Private/Vendor/Manage/ManageVendorAuth';
import ViewVendorAuthorization from 'Containers/Private/Vendor/View/ViewVendorAuthorization';
import AddVendorAuthorization from 'Containers/Private/Vendor/Add/AddVendorAuthorization';
import EditVendorAuthorization from 'Containers/Private/Vendor/Edit/EditVendorAuthorization';
import ManageWebServiceAccount from 'Containers/Private/WebService/Manage/ManageWebServiceAccount';
import EditWebServiceAccount from 'Containers/Private/WebService/Edit/EditWebServiceAccount';
//import CreatePSOProfile from 'Containers/Private/PSOProfile/Create/CreatePSOProfile';
//import CarryOverPSOProfile from 'Containers/Private/PSOProfile/Edit/CarryOverPSOProfile';
import ResetUserPassword from 'Containers/Private/UserProfile/ResetPassword/ResetUserPassword';
import SetupMfa from 'Containers/Private/UserProfile/MFA/SetupMfa';
import CDADataSubmission from 'Containers/Private/DataSubmission/CDADataSubmission';
import EditUserProfile from 'Containers/Private/UserProfile/UserProfileInfo/EditUserProfile';
import HelpCenter from 'Containers/Private/HelpCenter/HelpCenter';
import TermsOfUse from 'Containers/Public/TermsOfUse/TermsOfUse';
import ViewPSOProfile from 'Containers/Private/PSOProfile/View/ViewPSOProfile';
import ListDocuments from 'Containers/Private/DLMS/List/ListDocuments';
import CreateDocument from 'Containers/Private/DLMS/Create/CreateDocument';
//import EditUserProfilePic from 'Containers/Private/UserProfile/UserProfilePic/EditUserProfilePic';
import AltDataSubmission from 'Containers/Private/DataSubmission/AltDataSubmission';
import AltBatchDetail from 'Containers/Private/DataSubmission/AltBatchDetail';
import ViewDocument from 'Containers/Private/DLMS/View/ViewDocument';
import TermOfUse from 'Containers/Login/TermOfUse';
import Dashboard from 'Containers/Private/Dashboard/Dashboard';
import ManageTableau from 'Containers/Private/Tableau/List/ManageTableau';
import CreateTableauUser from 'Containers/Private/Tableau/Create/CreateTableauUser';
import ForgotPasswordMFA from 'Containers/Login/ForgotPasswordMFA';
import EditTableauUser from 'Containers/Private/Tableau/Edit/EditTableauUser';
import TableauReports from 'Containers/Private/Tableau/Reports/TableauReports';
import CreateTableauReportDef from 'Containers/Private/Tableau/Create/CreateTableauReportDef';
import CommentReport from 'Containers/Private/Comment/CommentReport';
import WebAnalyticReport from 'Containers/Private/WebAnalytic/WebAnalyticReport';
import ForgotPasswordResetPassword from 'Containers/Login/ForgotPasswordResetPassword';
import DSSummaryReport from 'Containers/Private/DataSubmissionSummary/DSSummaryReport';
import EditTableauReportDef from 'Containers/Private/Tableau/Edit/EditTableauReportDef';
import FirstTimeResetPassword from 'Containers/Login/FirstTimeResetPassword';
import FirstTimeSetupMFA from 'Containers/Login/FirstTimeSetupMFA';
import DataSubmissionReport from 'Containers/Private/DataSubmission/SubmissionReport/DataSubmissionReport';
import TableauReportView from 'Containers/Private/Tableau/Reports/TableauReportView';
import ResetPasswordMFA from 'Containers/Login/ResetPasswordMFA';
import ResetPasswordChangePWD from 'Containers/Login/ResetPasswordChangePWD';
import DataSubmission from 'Containers/Public/DataSubmission/DataSubmission';
import { PATHS } from 'Utils/PagePaths';
import PSODirectoryUpdate from "Containers/Private/PSODirectory/PSODirectoryUpdate";
import ViewBatch from "Containers/Private/PSODirectory/UpdateBatch/ViewBatch";
import { NotFound } from './NotFound';
//import { useEffect } from 'react';
//import Focus from './Focus';
import PrivacyPolicy from 'Containers/Public/PrivacyPolicy/PrivacyPolicy';
import Accessibility from 'Containers/Public/Accessibility/Accessibility';
import RetiredFormats from "../../Containers/Public/RetiredCommonFormats/RetiredFormats";
import SiteMap from 'Containers/Public/SiteMap/SiteMap';
import ExternalLinkDisclaimer from 'Containers/Public/ExternalLinkDisclaimer/ExternalLinkDisclaimer';
import BecomeAPSO from 'Containers/Public/BecomeAPSO/BecomeAPSO';
import Search from 'Containers/Public/Search/Search';
import HospitalV1_2 from 'Containers/Public/HospitalV1.2/HospitalV1_2';
import SurveillanceFormats from "../../Containers/Public/SurveillanceV1.0/SurveillanceFormats";
import HospitalV2_0 from 'Containers/Public/HospitalV2.0/HospitalV2_0';
import NursingHomeV1_0 from "../../Containers/Public/NursingHomeV1.0/NursingHomeV1_0";
import CommunityPharmacyV1_0 from "../../Containers/Public/CommunityPharmacyV1.0/CommunityPharmacyV1_0";
import DiagnosticSafetyV1_0 from "../../Containers/Public/DiagnosticSafetyV1.0/DiagnosticSafetyV1_0";
import DataSecurity from 'Containers/Public/DataSecurity/DataSecurity';
import AboutPSOPPC from "../../Containers/Public/AboutPSOPPC/AboutPSOPPC";
import { getPathCrumbs } from 'Components/Breadcrumbs/BreadcrumbsData';
import Breadcrumbs from 'Components/Breadcrumbs/Breadcrumbs';
import LearnFromTheData from 'Containers/Public/LearnFromTheData/LearnFromTheData';
import GetHelp from "../../Containers/Public/GetHelp/GetHelp";
import UserAccountTypes from "../../Containers/Public/UserAccountTypes/UserAccountTypes";
import UseCommonFormats from 'Containers/Public/UseCommonFormats/UseCommonFormats';
import ResourcesReference from "../../Containers/Private/Resources/ResourcesReference";
import { ga_log_content_group, ga_log_page_view, ga_log_sign_in, ga_log_sign_out, synchronousTaskAsync } from 'Utils/GA4/GTM';
import { useEffect } from 'react';
import { store } from 'Store';
import OpenForComment from 'Containers/Public/OpenForComment/OpenForComment';

const NUMBER_WORDS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];

const MatchRoutes = ({
    setBreadcrumbs,
    closeCollapsedSideNav
}) => {
    /*  PROTECTED ROUTES:
        https://www.robinwieruch.de/react-router-private-routes/ 
    */
    const location = useLocation();

    const loginState = store.getState().loginInfo;

    var segmentCount = null;

    var path = location.pathname;
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        if (loginState?.token) {
            synchronousTaskAsync(ga_log_sign_in).then((res) => {
                //console.log(res);
                ga_log_page_view(location);
            })
        }
        else {
            synchronousTaskAsync(ga_log_sign_out).then((res) => {
                //console.log(res);
                ga_log_page_view(location);
            })
        }


    }, [location.pathname])

    const getMatchPath = () => {
        var matchPath = "";
        const segments = path.split('/').filter(segment => segment !== '');

        //console.log("getMatchPath", segments, segments.includes("u"));

        if (segments.includes("u")) {
            var x = segments.indexOf("u");
            var sub = segments.slice(0, segments.indexOf("u"));
            segmentCount = sub.length;
            //console.log("getMatchPath", segmentCount);
            for (var x = 0; x < segmentCount; x++) {
                matchPath = matchPath + "/:" + NUMBER_WORDS[x] + "?";
            }
            //console.log("getMatchPath", matchPath);
        }
        return matchPath;
    }

    return (

        <Routes>
            {/* PUBLIC PAGES */}

            {/* Home */}
            <Route index element={<Home></Home>} />
            <Route path={PATHS.public.Homepage} element={<Home></Home>} />


            {/* Search */}
            <Route path={PATHS.public.Search} element={<Search />} />

            {/* Become a PSO */}
            <Route path={PATHS.public['User Account Types']} element={<UserAccountTypes />} />
            <Route path={PATHS.public['Become a PSO']} element={<BecomeAPSO />} />


            {/* Common Formats */}
            <Route path={PATHS.public['Use Common Formats']} element={<UseCommonFormats />} />
            <Route path={PATHS.public['Explore Common Format Data Elements']} element={"Explore Common Format Data Elements"} />
            <Route path={PATHS.public['Data Element Detail']} element={"Data Element Detail"} />
            {/* Comment out feedback for UAT; TODO!!!: 03/20/2026 revert for commenting tool development */}
            {/* <Route path={PATHS.public['Provide Feedback']} element={<OpenForComment />} /> */}
            <Route path={PATHS.public['Retired Common Formats']} element={<RetiredFormats />} />
            <Route path={PATHS.public['Community Pharmacy']} element={<CommunityPharmacyV1_0 />} />
            <Route path={PATHS.public['Diagnostic Safety']} element={<DiagnosticSafetyV1_0 />} />
            <Route path={PATHS.public['Hospital Version 1.2']} element={<HospitalV1_2 />} />
            <Route path={PATHS.public['Hospital Version 2.0']} element={<HospitalV2_0 />} />
            <Route path={PATHS.public['Nursing Home']} element={<NursingHomeV1_0 />} />
            <Route path={PATHS.public['Surveillance - Hospital']} element={<SurveillanceFormats />} />

            {/* Data Submission */}
            <Route path={PATHS.public['Submit Data']} element={<DataSubmission />} />
            <Route path={PATHS.public['Learn from the Data']} element={<LearnFromTheData />} />
            <Route path={PATHS.public['About PSOPPC']} element={<AboutPSOPPC />} />
            <Route path={PATHS.public['Get Help']} element={<GetHelp />} />
            <Route path={PATHS.public['Data Security']} element={<DataSecurity />} />

            {/* <Route path={PATHS.public['Read Help Articles']} element={"Read Help Articles"} />
            <Route path={PATHS.public['Join us for an Event']} element={"Join us for an Event"} />
            <Route path={PATHS.public['Educational Briefs']} element={"Educational Briefs"} /> */}

            {/* PSOPPC Website Terms and Agreement */}
            <Route path={PATHS.public['Terms of Use']} element={<TermsOfUse></TermsOfUse>} />
            <Route path={PATHS.public['Privacy Policy']} element={<PrivacyPolicy></PrivacyPolicy>} />
            <Route path={PATHS.public['Accessibility']} element={<Accessibility></Accessibility>} />
            <Route path={PATHS.public["External Link Disclaimer"]} element={<ExternalLinkDisclaimer />} />
            <Route path={PATHS.public['Site Map']} element={<SiteMap></SiteMap>} />


            {/*Login */}
            <Route path={PATHS.public['Sign In']} element={<Login
                //showCollapsedSideNav={showCollapsedSideNav}
                closeCollapsedSideNav={closeCollapsedSideNav}
            />} />

            {/* PRIVATE */}



            {/*Form mockup
            <Route path="/formMockup" element={<FormMockup />} />*/}

            {/*CDA Data Submission */}
            <Route path="/data/cda" element={<CDADataSubmission />} />
            {/* TODO: Remove!!! if decided, since managing test/prod submission using tabs */}
            {/* 
                            <Route path="/eventDataSubmission/testSubmission" element={<CDATestDataSubmission />} />
                            <Route path="/eventDataSubmission/productionSubmission" element={<CDAProdDataSubmission />} />
                        */}

            <Route path="/eventDataSubmission/displayBatchDetail" element={<CDABatchDetail />} />




            {/*First Time Term of Use*/}
            <Route path="/activation/token/:token" element={<TermOfUse />} />
            {/*First Time Reset Password*/}
            <Route path="/activation/token/:token/2" element={<FirstTimeResetPassword />} />
            {/*First Time Setup MFA*/}
            <Route path="/activation/token/:token/3" element={<FirstTimeSetupMFA />} />

            {/* Forgot password */}
            <Route path="/token/:token" element={<ForgotPasswordMFA />} />
            <Route path="/token/:token/2" element={<ForgotPasswordResetPassword />} />

            {/* Reset  Password */}
            <Route path="/password/token/:token" element={<ResetPasswordMFA />} />
            <Route path="/password/token/:token/2" element={<ResetPasswordChangePWD />} />

            {/*TabDatatable*/}
            {/* <Route path="/tabDatatable" element={<TabDatatable />} /> */}

            {/*New Org */}
            <Route path="/manage/:oT/createOrganization" element={<CreateOrganization />} />

            {/*Edit Org */}
            <Route path="/manage/:oT/editOrganization" element={<EditOrganization />} />

            {/*View Org */}
            <Route path="/manage/:oT/viewOrganization" element={<ViewOrganization />} />

            {/*List Org */}
            {/*<Route element={<ProtectedRoute user={loginState.token} />}*/}
            <Route path="/manage/organization" element={<ListOrganization setBreadcrumbs={setBreadcrumbs}></ListOrganization>} />
            {/*</Route>*/}


            {/* List Users */}
            <Route path="/manage/user" element={<ListUsers />} />
            {/* Create User */}
            <Route path="/manage/createUser" element={<CreateUser />} />
            {/* View User */}
            <Route path="/manage/viewUser" element={<ViewUser />} />
            {/* Edit Users */}
            <Route path="/manage/editUser" element={<EditUser />} />

            {/* List Documents */}
            <Route path="/manage/document" element={<ListDocuments />} />
            {/* List Documents */}
            <Route path="/manage/createDocument" element={<CreateDocument />} />
            {/* View Document */}
            <Route path="/manage/viewDocument" element={<ViewDocument />} />


            {/* List Tableau Users */}
            <Route path="/manage/tableau" element={<ManageTableau />} />
            {/* Create Tableau User */}
            <Route path="/manage/tableau/createUser" element={<CreateTableauUser />} />
            {/* Edit Tableau User */}
            <Route path="/manage/tableau/editUser" element={<EditTableauUser />} />
            {/* Create Tableau Report Def */}
            <Route path="/manage/tableau/createReportDefinition" element={<CreateTableauReportDef />} />
            {/* Edit Tableau Report Def */}
            <Route path="/manage/tableau/editReportDefinition" element={<EditTableauReportDef />} />

            {/* Tableau Interactive Reports */}
            <Route path="/analytics/dashboard" element={<TableauReports />} />
            <Route path="/analytics/dashboard/view" element={<TableauReportView />} />



            {/* List PSO Profiles */}
            <Route path="/manage/profile" element={<ListPSOProfiles />} />
            {/* Create PSO Profile */}
            <Route path="/manage/createPSOProfile" element={<ViewPSOProfile pageType="CREATE"></ViewPSOProfile>} />
            {/* Edit PSO Profile */}
            <Route path="/manage/editPSOProfile" element={<ViewPSOProfile pageType="EDIT"></ViewPSOProfile>} />
            {/* Carry Over PSO Profile */}
            <Route path="/manage/carryOverPSOProfile" element={<ViewPSOProfile pageType="CARRY"></ViewPSOProfile>} />
            {/* View PSO Profile */}
            <Route path="/manage/viewPSOProfile" element={<ViewPSOProfile pageType="VIEW"></ViewPSOProfile>} />

            {/* Help Center */}
            <Route path="/helpcenter" element={<HelpCenter />} />

            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/*<Route path="/eventDataSubmission/displayBatchDetail/:id" element={<CDABatchDetail />} />*/}
            {/*<Route path="/eventDataSubmission/displayBatchDetail/:id" element={<Navigate replace to="/eventDataSubmission/displayBatchDetail" state={useLocation().state} />} />*/}




            {/* List Vendor Authorizations */}
            <Route path="/manage/authorization" element={<ManageVendorAuth />} />
            {/* View Vendor Authorization */}
            <Route path="/manage/viewVendorAuthorization" element={<ViewVendorAuthorization />} />
            {/* Add Vendor Authorization */}
            <Route path="/manage/addVendorAuthorization" element={<AddVendorAuthorization />} />
            {/* Edit Vendor Authorization */}
            <Route path="/manage/editVendorAuthorization" element={<EditVendorAuthorization />} />

            {/* List Web Service Accounts */}
            <Route path="/manage/wsa" element={<ManageWebServiceAccount />} />
            {/* Edit Web Service Accounts by Admin*/}
            <Route path="/manage/editWebServiceAccount" element={<EditWebServiceAccount />} />
            {/* Edit Web Service Accounts by Level3*/}
            <Route path="/manage/webservice" element={<EditWebServiceAccount />} />

            {/**Reset User Password */}
            <Route path="/manage/resetUserPassword" element={<ResetUserPassword />} />
            {/**Setup MFA */}
            <Route path="/manage/setupMfa" element={<SetupMfa />} />
            {/**Eidt User Profile */}
            <Route path="/manage/editUserProfile" element={<EditUserProfile />} />
            {/**Eidt User Profile Picture */}
            {/* <Route path="/manage/editUserProfilePicture" element={<EditUserProfilePic />} /> */}

            {/*Alt Data Submission */}
            <Route path="/data/alternate" element={<AltDataSubmission />} />
            <Route path="/eventDataSubmission/altBatchDetail" element={<AltBatchDetail />} />

            {/*Comment Download Report */}
            <Route path="/report/comment" element={<CommentReport />} />


            <Route path="/report/analytic" element={<WebAnalyticReport />} />

            <Route path="/report/submissionSummary" element={<DSSummaryReport />} />



            <Route path="/report/submission" element={<DataSubmissionReport />} />

            <Route path="/manage/directory" element={<PSODirectoryUpdate />} />

            <Route path="/manage/viewBatch" element={<ViewBatch />} />

            <Route
                path={"" + getMatchPath() + "/u/:id"}
                element={
                    <Navigate replace relative={"path"} to={"../.."} state={location.state} />
                }
            />

            <Route path="/resources/reference" element={<ResourcesReference />} />

            {/* Catch all unknown routes */}
            <Route path="*" element={<NotFound />} />

        </Routes>

    )
}

export default MatchRoutes;
